import { Injectable } from '@angular/core';
import constantURL from '../../../../shared/constantURL';
import { BaseLoggedInPostService } from '../../../../shared/services/base-logged-in-post.service';

@Injectable({
  providedIn: 'root',
})
export class SendMarketingSmsService extends BaseLoggedInPostService {
  _path = constantURL.seller.saveSmsMarketingRequest;

  private mobileNumbersArray: string[] = [];
  /*
   * @return {Observable<string>} : mobileNumbersArray
   */
  public getMobilesArray(): string[] {
    return this.mobileNumbersArray;
  }
  /*
   * @param {string} message : mobileNumbersArray
   */
  public setMobilesArray(mobiles: string[]): void {
    this.mobileNumbersArray = mobiles;
  }
}
